var styleDataHash = "6b53412e";
const injectCss = () => {
  var css = `.gH81a{background-color:#fff;border:1px solid #ededed;border-radius:6px;box-shadow:0 4px 8px 0 rgba(0,0,0,.07);display:flex;height:43px;overflow:hidden;position:absolute;transform:translate(-50%,-100%);transition:all .5s ease-out}._47HgP{align-items:center;background:#fff;border:none;cursor:pointer;display:flex;justify-content:center;width:43px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var viewer_inline_toolbar_rtlignore_default = {
  "toolbar": "gH81a",
  "button": "_47HgP"
};
export {
  viewer_inline_toolbar_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=viewer-inline-toolbar.rtlignore-scss.js.map
